/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface AllShipmentsLocationAnalytics
 */
export interface AllShipmentsLocationAnalytics {
  /**
   *
   * @type {string}
   * @memberof AllShipmentsLocationAnalytics
   */
  location: string;
  /**
   *
   * @type {number}
   * @memberof AllShipmentsLocationAnalytics
   */
  count: number;
  /**
   *
   * @type {number}
   * @memberof AllShipmentsLocationAnalytics
   */
  bookedCount: number;
  /**
   *
   * @type {number}
   * @memberof AllShipmentsLocationAnalytics
   */
  totalMoneyIn: number;
  /**
   *
   * @type {number}
   * @memberof AllShipmentsLocationAnalytics
   */
  totalMoneyOut: number;
}

/**
 * Check if a given object implements the AllShipmentsLocationAnalytics interface.
 */
export function instanceOfAllShipmentsLocationAnalytics(
  value: object,
): value is AllShipmentsLocationAnalytics {
  if (!("location" in value) || value["location"] === undefined) return false;
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("bookedCount" in value) || value["bookedCount"] === undefined)
    return false;
  if (!("totalMoneyIn" in value) || value["totalMoneyIn"] === undefined)
    return false;
  if (!("totalMoneyOut" in value) || value["totalMoneyOut"] === undefined)
    return false;
  return true;
}

export function AllShipmentsLocationAnalyticsFromJSON(
  json: any,
): AllShipmentsLocationAnalytics {
  return AllShipmentsLocationAnalyticsFromJSONTyped(json, false);
}

export function AllShipmentsLocationAnalyticsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AllShipmentsLocationAnalytics {
  if (json == null) {
    return json;
  }
  return {
    location: json["location"],
    count: json["count"],
    bookedCount: json["bookedCount"],
    totalMoneyIn: json["totalMoneyIn"],
    totalMoneyOut: json["totalMoneyOut"],
  };
}

export function AllShipmentsLocationAnalyticsToJSON(
  json: any,
): AllShipmentsLocationAnalytics {
  return AllShipmentsLocationAnalyticsToJSONTyped(json, false);
}

export function AllShipmentsLocationAnalyticsToJSONTyped(
  value?: AllShipmentsLocationAnalytics | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    location: value["location"],
    count: value["count"],
    bookedCount: value["bookedCount"],
    totalMoneyIn: value["totalMoneyIn"],
    totalMoneyOut: value["totalMoneyOut"],
  };
}
